import { Controller, useFormContext } from "react-hook-form";
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  FormControl,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CheckIcon from "@mui/icons-material/Check";
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import './RFH.scss';
import React from "react";

// ----------------------------------------------------------------------

const CustomRadio = styled(Radio)(({ theme }) => ({
  "&.Mui-checked": {
    color: "#00C0E4", // Custom blue color for checked state
  },
}));

const CustomRadioIcon = () => (
  <span
    className="radio-unchecked-icon"
  />
);

const CustomCheckedIcon = () => (
  <span
    className="radio-checked-icon"
  >
    <CheckIcon className="check-icon" />
  </span>
);

export const RHFRadioGroup = React.memo(({ name = "", options = [], row = false, isCircularRadio = false, className, ...other }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      className="radio-group"
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error}>
          <RadioGroup {...field} row={row} {...other} className={className}>
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={
                  isCircularRadio ?
                    <CustomRadio
                      icon={<RadioButtonUncheckedIcon />}
                      checkedIcon={<RadioButtonCheckedIcon />}
                    />
                    :
                    <CustomRadio
                      icon={<CustomRadioIcon />}
                      checkedIcon={<CustomCheckedIcon />}
                    />
                }
                label={option.label}
              />
            ))}
          </RadioGroup>
          {error && <FormHelperText>{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
});
